<script>
export default{
}
</script>

<template>
  <div class='p-2 text-center text-uppercase' style='background: #fafafa;'>  --- {{ $t('reports.components_name.page_break') }} --- </div>
</template>

